import { Layers, Compass, BarChart3, Timer, ListChecks } from "lucide-react";

const STATS = [
  { icon: ListChecks, value: "252", label: "Uniquely Illustrated Assessment Items" },
  { icon: Layers, value: "40", label: "Real Behavioural, Cognitive & Professional Dimensions" },
  { icon: Compass, value: "6", label: "Career Interest Domains (RIASEC Model)" },
  { icon: BarChart3, value: "57+", label: "Career Families Mapped" },
  { icon: Timer, value: "35-45", label: "Minutes, Multi-Format Assessment" },
];

export default function StatsStrip() {
  return (
    <section className="bg-slate-950 border-y border-slate-800/60 py-12 px-6" data-testid="stats-strip">
      <div className="max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
        {STATS.map((s) => (
          <div key={s.label} className="text-center sm:text-left">
            <s.icon className="h-5 w-5 text-cyan-400 mb-3 mx-auto sm:mx-0" />
            <p className="font-heading text-2xl sm:text-3xl font-bold text-white">{s.value}</p>
            <p className="text-xs text-slate-500 mt-1 leading-snug">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
